export default __webpack_public_path__ + "static/media/american-express.5634fd33.svg";